/**
 * Obal editoru poznámky. Editor je těžší kus kódu, proto se stahuje až ve
 * chvíli, kdy ho někdo opravdu otevře; do té doby je vidět jen rám, takže
 * při načtení nic neposkočí.
 */
import React from "react";

const PoznamkaEditor = React.lazy(() => import("./PoznamkaEditor.jsx"));

export default function PoznamkaPole({ value, onChange, placeholder, minHeight = "12rem", autoFocus = false }) {
  return (
    <React.Suspense
      fallback={
        <div className="rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm text-slate-400" style={{ minHeight }}>
          Načítám editor…
        </div>
      }
    >
      <PoznamkaEditor value={value} onChange={onChange} placeholder={placeholder} minHeight={minHeight} autoFocus={autoFocus} />
    </React.Suspense>
  );
}
